module.exports = __webpack_public_path__ + "assets/be8a66d01951ca6b8eb6ebd2b15ee7c1.mp4";